import axios from "axios";
import { useState, useEffect } from "react";
import "./ForgotPassword.css";
import logo1024 from "../../../assets/logo1024.png";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/loader/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotPassword() {
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [conPassword, setConPassword] = useState();
  const [otp, setotp] = useState();
  const [errorMessage, setErrormessage] = useState({
    phone: "",
    password: "",
    otp: "",
  });
  const notify = (message) => toast(message);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const checkPassword = (password, conPassword) => {
    const regPassword =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_+()<>,./:";'{}])(?=.{8,})/;
    if (regPassword.test(password) === true && password === conPassword) {
      return true;
    } else {
      setPassword("");
      setConPassword("");
      return false;
    }
  };

  const checkPhone = (phone) => {
    if (phone.length !== 10) {
      return false;
    } else {
      return true;
    }
  };

  const validate = () => {
    setLoading(true);
    let errorMessage = {};
    errorMessage.password =
      password.length !== 0
        ? password === conPassword
          ? checkPassword(password, conPassword)
            ? ""
            : "Use strong password or password"
          : "Passwords do not match"
        : "Please enter required fields";
    errorMessage.phone =
      phone.length !== 0
        ? checkPhone(phone)
          ? ""
          : "Invalid Phone Number"
        : "Please enter required fields";
    errorMessage.otp = otp.length !== 0 ? "" : "Please enter required fields";
    setErrormessage({ ...errorMessage });
    setLoading(false);
    return Object.values(errorMessage).every((newData) => newData === "");
  };

  const sendOtp = async (phone) => {
    try {
      // const proxyUrl = "/api/sendOtp?phone=" + phone;
      const proxyUrl = `/api/sendOtp?phone=${phone}&pushToken=${null}`;
      axios
        .post(proxyUrl, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          notify("OTP send on +91" + phone, {
            type: "success",
            theme: theme === "dark" ? "light" : "dark",
          });
          console.log(response.data);
        })
        .catch((error) => {
          notify("Something went wrong", {
            type: "error",
            theme: theme === "dark" ? "light" : "dark",
          });
        });
    } catch (error) {
      notify("Something went wrong", {
        type: "error",
        theme: theme === "dark" ? "light" : "dark",
      });
    }
  };
  const forgotPassword = async (phone, otp, password) => {
    setLoading(true);
    try {
      const proxyUrl =
        "/api/changePassword" +
        "?phone=" +
        phone +
        "&otp=" +
        otp +
        "&password=" +
        password;
      setLoading(true);
      axios
        .post(proxyUrl, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          console.log(response.data);
          if (response.status == 202) {
            notify("Password changed successfully", {
              type: "success",
              theme: theme === "dark" ? "light" : "dark",
            });
            navigate("/loginwithpassword");
          }
        })
        .catch((error) => {
          console.error(error); // handle any errors here
          setLoading(false);
          notify("Something went wrong", {
            type: "error",
            theme: theme === "dark" ? "light" : "dark",
          });
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      notify("Something went wrong", {
        type: "error",
        theme: theme === "dark" ? "light" : "dark",
      });
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      forgotPassword(phone, otp, password);
    }
  };

  useEffect(() => {
    if (phone && phone.length === 10) {
      console.log(phone);
      sendOtp(phone);
    }
  }, [phone]);
  const theme =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  return (
    <div
      className={theme === "dark" ? "containerForgotDark" : "containerForgot"}
    >
      <ToastContainer />
      <form
        className={theme === "dark" ? "formDark" : "form"}
        onSubmit={handleSubmit}
      >
        <div className="imgDiv">
          <img className="imgSty" src={logo1024} alt="Logo" />
        </div>
        <div className="field">
          <label className={theme === "dark" ? "labelDark" : "label"}>
            Phone Number
          </label>
          <input
            type="tel"
            value={phone}
            placeholder="Enter Phone"
            maxLength={10}
            minLength={10}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            required
          />
          {errorMessage.phone && (
            <div className="error"> {errorMessage.phone} </div>
          )}
        </div>
        <div className="field">
          <label className={theme === "dark" ? "labelDark" : "label"}>
            New Password
          </label>
          <input
            type="password"
            value={password}
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />{" "}
          {errorMessage.password && (
            <div className="error"> {errorMessage.password} </div>
          )}
        </div>
        <div className="field">
          <label className={theme === "dark" ? "labelDark" : "label"}>
            Confirm Password
          </label>
          <input
            type="password"
            value={conPassword}
            placeholder="Confirm Password"
            onChange={(e) => setConPassword(e.target.value)}
            required
          />{" "}
          {errorMessage.password && (
            <div className="error"> {errorMessage.password} </div>
          )}
        </div>
        <div className="field">
          <label className={theme === "dark" ? "labelDark" : "label"}>
            OTP
          </label>
          <input
            type="text"
            maxLength={6}
            value={otp}
            onChange={(e) => setotp(e.target.value)}
            placeholder="Enter OTP"
            required
          />
          {errorMessage.otp && (
            <div className="error"> {errorMessage.otp} </div>
          )}
        </div>

        <button className="button" type="submit" disabled={loading}>
          {loading ? <Loader /> : "Reset Password"}
        </button>
      </form>
    </div>
  );
}

export default ForgotPassword;
